/** Primary admin navigation (Players only for now). */
export const PLAYERS_NAV = [
  {
    permission_name: 'players',
    title: 'Players',
    path: '/dashboard/players',
    icon: 'mdi:cricket'
  }
];

export function buildLegacyPermissions() {
  return PLAYERS_NAV;
}

export function storeAdminSession({ user, accessToken, permissions }) {
  localStorage.setItem('token', accessToken);
  localStorage.setItem('user', JSON.stringify(user));
  localStorage.setItem('adminPermissionSlugs', JSON.stringify(permissions || []));
  localStorage.setItem('permissions', JSON.stringify(buildLegacyPermissions()));
}

export function clearAdminSessionExceptRemember() {
  const rememberEmail = localStorage.getItem('email');
  const rememberPassword = localStorage.getItem('password');
  const rememberMe = localStorage.getItem('remember');

  localStorage.clear();

  if (rememberMe === 'true') {
    localStorage.setItem('email', rememberEmail);
    localStorage.setItem('password', rememberPassword);
    localStorage.setItem('remember', rememberMe);
  }
}

export function getDefaultDashboardPath() {
  const permissions = JSON.parse(localStorage.getItem('permissions') || '[]');
  const players = permissions.find((item) => item.permission_name === 'players');
  if (players?.path) {
    return players.path;
  }

  return permissions[0]?.path || '/dashboard/players';
}

export const RESET_EMAIL_KEY = 'clutch_reset_email';
export const RESET_TOKEN_KEY = 'clutch_reset_token';
